export default "__VITE_ASSET__0b4b2bf6__"